/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NetCloudIcon20Light = forwardRef('NetCloudIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.045 6.944a5.126 5.126 0 0 1 9.747-1.44A5.25 5.25 0 1 1 14 16H5.25a4.625 4.625 0 0 1-1.205-9.056ZM9.125 3.5a4.125 4.125 0 0 0-4.117 3.871.5.5 0 0 1-.395.46A3.626 3.626 0 0 0 5.293 15H14a4.25 4.25 0 1 0-.477-8.474.5.5 0 0 1-.525-.324A4.127 4.127 0 0 0 9.125 3.5Z" })));
});
